/**
 * APIUrls file for CMS change cover related api endpoints.
 */

const BASE_API_URL = '/api/data/v9.1';

export const CHANGE_COVER_APIS = {
  GET_MEMBERSHIP_DETAILS: `${BASE_API_URL}/dhl_membershipmemberses`,
  GET_MEMBERSHIP_POLICIES: `${BASE_API_URL}/dhl_membershippolicies`,
  GET_PRODUCT_RECOMMENDATIONS: `${BASE_API_URL}/dhl_ChangeofCoverProductRecommendationAPI`,
  GET_PRICE: `${BASE_API_URL}/dhl_PricingCalltoOHI`,
  GET_COVER_DETAILS: `${BASE_API_URL}/dhl_RetrieveCoverDetails`,
  GET_FUND_NAMES: `${BASE_API_URL}/competitors`,
  GET_REBATE_TIERS: `${BASE_API_URL}/dhl_rebatetiers`,
  RETRIEVE_NEW_SCALE: `${BASE_API_URL}/dhl_RetrieveNewPolicyScale`,
  RETRIEVE_NEW_PREMIUM: `${BASE_API_URL}/dhl_RetrieveNewPolicyPremium`,
  FETCH_MEMBER_PRODUCT_HISTORY: `${BASE_API_URL}/dhl_FetchMemberProductHistory`,
  GET_MEMBER_POLICIES: `${BASE_API_URL}/dhl_fetchMemberPolicies`

};

export const CAPTURE_ADDITIONAL_INFORMATION = {
  GET_TERMINATION_REASONS: `${BASE_API_URL}/dhl_RetrievingTerminationReasons`,
  GET_FUND_NAMES: `${BASE_API_URL}/competitors`,
  GET_VETERAN_CARD_DETAILS: (contactGUID) => {
    return `${BASE_API_URL}/contacts(${contactGUID})/dhl_contact_dhl_veterancard_Member`;
  },
  GET_CONCESSION_CARD_DETAILS: (contactGUID) => {
    return `${BASE_API_URL}/contacts(${contactGUID})/dhl_contact_dhl_paymentdetails_contactid`;
  },
  OVERCOVERAGE_DUPLICATE_PERSON: `${BASE_API_URL}/dhl_GetOverCoverage`,
  GET_PREMIUM_CONFIRMATION: `${BASE_API_URL}/dhl_CreateMembership`,
  UPLOAD_FILE: `${BASE_API_URL}/dhl_UploadFileAction`,
  SUBMIT_CHANGE_COVER: `${BASE_API_URL}/dhl_Submitchangeofcover`,
  GET_PERSON_OVER_COVERAGE: `${BASE_API_URL}/dhl_GetPersonOverCoverage`,
};

export default CHANGE_COVER_APIS;
